import { render, staticRenderFns } from "./newspaper-slug.vue?vue&type=template&id=738b3e77&"
import script from "./newspaper-slug.vue?vue&type=script&lang=js&"
export * from "./newspaper-slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports